import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref } from "vue";
import BrandBalanceAlert from "@js/vue/domain/invoice/components/shared/BrandBalanceAlert.vue";
import { route } from "ziggy-js";
import { formatCurrency, formatShortDate } from "@js/utilities/formatters";
import { ArrowRight, X } from "lucide-vue-next";
import { getUserBrandOpenInvoices } from "@js/api/domain/invoice";
import InvoiceOrders from "@js/vue/domain/invoice/components/shared/InvoiceOrders.vue";
import OrderToggleButton from "@js/vue/domain/invoice/components/shared/OrderToggleButton.vue";
import CollapsibleCard from "@js/vue/components/ui/CollapsibleCard.vue";
import LoadingSpinner from "@js/vue/components/ui/LoadingSpinner.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BrandCard',
    setup(__props, { expose: __expose }) {
        __expose();
        const openInvoices = ref([]);
        const isLoading = ref(true);
        const error = ref('');
        const expandedRows = ref(new Set());
        const toggleShowOrders = (qbiID) => {
            if (expandedRows.value.has(qbiID)) {
                expandedRows.value.delete(qbiID);
            }
            else {
                expandedRows.value.add(qbiID);
            }
        };
        const fetchInvoices = async () => {
            try {
                isLoading.value = true;
                error.value = '';
                const response = await getUserBrandOpenInvoices();
                openInvoices.value = response.data.invoices;
            }
            catch (err) {
                error.value = 'Failed to load invoices';
            }
            finally {
                isLoading.value = false;
            }
        };
        onMounted(() => {
            fetchInvoices();
        });
        const __returned__ = { openInvoices, isLoading, error, expandedRows, toggleShowOrders, fetchInvoices, BrandBalanceAlert, get route() { return route; }, get formatCurrency() { return formatCurrency; }, get formatShortDate() { return formatShortDate; }, get ArrowRight() { return ArrowRight; }, get X() { return X; }, InvoiceOrders, OrderToggleButton, CollapsibleCard, LoadingSpinner };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
